import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { Controller, useForm } from 'react-hook-form'
import { NewsQuery } from '../../../types/News'
import SuccessButton from '../../ui/SuccessButton'
import FilterContainer from '../FilterContainer'
import { Ref, useContext, useImperativeHandle } from 'react'
import GlobalContext from '../../../contexts/GlobalContext'
import React from 'react'

interface Props {
  onSearch: (values: NewsQuery) => void
}

export interface NewsFilterRefType {
  getValues: () => NewsQuery
}
const NewsFilters = ({ onSearch }: Props, ref: Ref<NewsFilterRefType>) => {
  const { setMobileFilterActive } = useContext(GlobalContext)
  const { control, getValues } = useForm<NewsQuery>({
    defaultValues: {
      search: ''
    }
  })

  const onSubmit = () => {
    const query = getValues()
    onSearch(query)
    setMobileFilterActive()
  }

  useImperativeHandle(ref, () => ({ getValues }))

  return (
    <FilterContainer>
      <form
        className="w-full"
        noValidate
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onSubmit()
        }}>
        <Grid
          spacing={0.5}
          container
          sx={{
            px: { lg: 0, xs: 1 }
          }}
          direction="row"
          justifyContent="start"
          alignItems="stretch">
          <Grid size="grow">
            <Controller
              name="search"
              control={control}
              render={({ field }) => (
                <TextField
                  hiddenLabel
                  fullWidth={true}
                  size="small"
                  classes={{
                    root: '!bg-white !rounded-none'
                  }}
                  variant="outlined"
                  placeholder="Search News Articles"
                  {...field}
                />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 'auto' }} className="min-w-[200px]">
            <SuccessButton onClick={onSubmit}>SEARCH</SuccessButton>
          </Grid>
        </Grid>
      </form>
    </FilterContainer>
  )
}

export default React.forwardRef(NewsFilters)
